import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { DataBase } from '@og_soft/data-base';
import { BehaviorSubject } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import * as mime from 'mime/lite';
import { fileToBase64 } from '@og_soft/file';

class DataFileModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.7", ngImport: i0, type: DataFileModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFileModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFileModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

class DataFiles extends DataBase {
    constructor() {
        super(...arguments);
        this._uploadedFiles = []; // Aktuální stav nahrávaných souborů.
        this._files$ = new BehaviorSubject([]); // Observable se stavem nahrávaných souborů
    }
    /**
     * Stream všech nahrávaných souborů, aktualizuje se při každé změně.
     */
    get files() {
        return this._files$;
    }
    actualizeUploadedFiles() {
        this._files$.next(this._uploadedFiles);
    }
    configureUrl(config) {
        this.baseurl = config.mangoUrl;
    }
    /**
     * Přidá soubory do fronty, spustí jejich upload a vrátí observable která úspěšný upload
     */
    addFiles(files) {
        // Připravím si objekt, který budu vracet.
        const successfulUploads = [];
        if (files.length > 0) {
            for (const file of files) {
                const successfulUpload = new BehaviorSubject(null);
                const fileModel = {
                    name: file.name,
                    fileObj: file,
                    uploadPercentage: 0,
                    uploadStarted: false,
                    uploadFinished: false,
                    successfulUpload,
                };
                this._uploadedFiles.push(fileModel);
                this.actualizeUploadedFiles();
                successfulUploads.push(successfulUpload);
            }
        }
        // Zahájím uploadování pro všechny soubory, přičemž zachycuji progress
        this._uploadedFiles.forEach((file) => {
            if (!file.uploadStarted) {
                fileToBase64(file.fileObj).then((data) => {
                    file.base64 = data + '';
                    file.uploadStarted = true;
                    const postData = {
                        base64: data,
                        name: file.fileObj.name,
                    };
                    const options = {
                        reportProgress: true,
                        observe: 'events',
                    };
                    file.subscription = this.post(postData, options).subscribe((event) => {
                        // progress update
                        if (event.type === HttpEventType.UploadProgress) {
                            file.uploadPercentage = (100 / event.total) * event.loaded;
                            file.uploadPercentage = Math.floor(file.uploadPercentage);
                            this.actualizeUploadedFiles();
                        }
                        // finished
                        if (event.type === HttpEventType.Response) {
                            file.uploadFinished = true;
                            file.uploadPercentage = 100;
                            file.uploadResult = event.status;
                            file.uploadFileName = event.body.name;
                            file.newObject = event.body;
                            this.actualizeUploadedFiles();
                            file.successfulUpload.next({
                                file,
                                success: true,
                            });
                        }
                        // error
                        if (event.type === HttpEventType.ResponseHeader) {
                            if (event.status !== 200) {
                                file.uploadFinished = true;
                                file.uploadResult = event.status;
                                this.actualizeUploadedFiles();
                                file.successfulUpload.next({
                                    file,
                                    success: false,
                                });
                            }
                        }
                    });
                });
            }
        });
        return successfulUploads;
    }
    removeFile(file) {
        if (file.subscription) {
            file.subscription.unsubscribe();
        }
        this._uploadedFiles = this._uploadedFiles.filter((el) => el !== file);
        this.actualizeUploadedFiles();
    }
    uploadFinished() {
        for (const file of this._uploadedFiles) {
            if (!file.uploadFinished) {
                return false;
            }
        }
        return true;
    }
    downloadFile($event, id, fileName) {
        $event.preventDefault();
        const progress$ = new BehaviorSubject({
            finished: false,
            loaded: 0,
            name: fileName,
            started: false,
            total: 0,
            percentage: 0,
            error: false,
        });
        const options = {
            observe: 'events',
            reportProgress: true,
            responseType: 'blob',
        };
        progress$.value.subscription = this.getone(id, {}, 60, options).subscribe((event) => {
            progress$.value.started = true;
            if (event.type === HttpEventType.DownloadProgress) {
                progress$.value.loaded = event.loaded;
                progress$.value.total = event.total;
                if (event.total > 0) {
                    let percentage = (event.loaded / event.total) * 100;
                    percentage = Math.round((percentage + Number.EPSILON) * 100) / 100;
                    progress$.value.percentage = percentage;
                }
                progress$.next(progress$.value);
            }
            if (event.type === HttpEventType.Response) {
                progress$.value.finished = true;
                progress$.value.loaded = progress$.value.total;
                progress$.value.percentage = 100;
                progress$.next(progress$.value);
                progress$.complete();
                const fileType = mime.getType(fileName);
                const blob = new Blob([event.body], { type: fileType });
                const url = window.URL.createObjectURL(blob);
                // Toto se za mě chová nejlíp: typy které prohlížeč rozezná otevře v novém okně,
                // a ty které neumí otevřít dá stahovat.
                window.open(url);
                // Alternativa: stažení souboru.
                // let downloadLink = document.createElement("a");
                // downloadLink.href = url;
                // downloadLink.download = fileName;
                // document.body.appendChild(downloadLink);
                // downloadLink.click();
                // document.body.removeChild(downloadLink);
            }
        }, () => {
            progress$.value.error = true;
            progress$.next(progress$.value);
            progress$.complete();
        });
        progress$.next(progress$.value);
        return progress$.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFiles, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFiles, providedIn: DataFileModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.7", ngImport: i0, type: DataFiles, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: DataFileModule,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DataFileModule, DataFiles };
